import { SettingsProvider } from '$providers/settings';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

@Component({
  selector: 'page-termo-aceite-view',
  templateUrl: 'termo-aceite-view.html',
})
export class TermoAceiteViewPage {

  termoAceite: String = "";

  concordo: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController, private settingsProvider: SettingsProvider) {
    const settings = navParams.get("settings");
    if (settings) {
      this.termoAceite = settings.termoAceite;
    }

    if (!this.termoAceite || !this.termoAceite.length) {
      this.concordo = true;
      this.confirmar();
    }
  }

  confirmar() {
    this.settingsProvider.setAgreeTerms(this.concordo);
    let data = { concordo: this.concordo };
    this.viewCtrl.dismiss(data);
  }
}



// WEBPACK FOOTER //
// ./src/pages/termo-aceite-view/termo-aceite-view.ts